export function getRestUrl(path: string): string {
  const baseUrl = process.env.NEXT_PUBLIC_REST_URL as string;
  return `${baseUrl}${path}`;
}
